export default {"src":"/_next/static/media/illustration-lobbied.3aedbd03.svg","height":82,"width":90};